import React from 'react';
import './Footer.css';
import {
  Row,
  Col
} from 'reactstrap';
import { GrFacebook, GrTwitter, GrLinkedin} from "react-icons/gr";
import { SiGmail } from "react-icons/si";


const Footer = (props) => {
  return (
    <div className="footerDiv">
        <div className="container">
            <Row>
                <Col lg={4}>
                    <div align="left" className="p-5">
                        <p className="footerTitle">ThothIT</p>
                        <span className="footerFont">
                        <p align="left">8615 Freeport Pkwy Ste 175</p>
                        <p align="left">Irving TX 75063</p>
                        <p align="left">(720) 254-0739</p>
                        <p align="left">hr@thothit.net</p>
                        </span>   
                    </div>
                </Col>
                <Col lg={4}>
                    <div align="left" className="p-5">
                        <p className="footerTitle">ABOUT ThothIT</p>
                        <span className="footerFont">
                        <p>ThothIT LLC is an integrated IT solutions and services provider with its
                            headquarter in Irving, Texas. We offer Software Development, Web Application 
                            development, Mobile Application Development, Ecommerce Solutions and enterprise 
                            planning solutions to various companies.</p>
                        </span> 
                    </div>
                </Col>
                <Col lg={4}>
                    <div align="left" className="p-5">
                        <p className="footerTitle">QUICK LINKS</p>
                        <span className="footerFont" >
                            <a href="/">HOME</a><hr/>
                            <a href="/services">SERVICES</a><hr/>
                            <a href="/about">ABOUT US</a><hr/>
                            <a href="/posts">POSTS</a><hr/>
                            <a href="/contact">CONTACT</a><hr/>
                            {/* <a href="/careers">CAREERS</a> */}
                        </span>
                    </div>
                </Col>
                <Col align="left" className="footerFont pl-5">
                <p> <a href="/">© ThothIT</a></p>
                </Col>
                <Col align="right">
                <a className="m-1" href="https://www.facebook.com/"><GrFacebook/></a>
                <a className="m-1" href="https://twitter.com/"><GrTwitter/></a>
                <a className="m-1" href="https://www.linkedin.com/company/thothit/"><GrLinkedin/></a>
                <a className="m-1" href="mailto:application@thothit.net"><SiGmail/></a>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default Footer;